import type { FC } from 'react';

import { useTranslation } from '@crehana/i18n';

import { useAttributesUploadContext } from '@/views/AdminDashboard/components/AttributesDrawer/UserAttributesUploadContext';
import Steps from '@/views/AdminDashboard/components/Stepper';

interface StepperProps {
  isDark?: boolean;
}

const Stepper: FC<React.PropsWithChildren<StepperProps>> = ({ isDark }) => {
  const { t } = useTranslation();
  const { currentStep } = useAttributesUploadContext();

  const steps = [t('ATTR_STEP_1'), t('ATTR_STEP_2'), t('ATTR_STEP_3')];

  return (
    <>
      {currentStep !== 4 && (
        <div className="flex flex-col pb-40">
          <Steps isDark={isDark} steps={steps} currentStep={currentStep} />
        </div>
      )}
    </>
  );
};

export default Stepper;
